/** HTTP / mobil Safari uyumlu kopyalama ve indirme */

export async function copyTextSafe(text) {
  const value = String(text ?? '');
  if (!value.trim()) return false;

  if (window.isSecureContext && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(value);
      return true;
    } catch {
      // execCommand yedek
    }
  }

  try {
    const el = document.createElement('textarea');
    el.value = value;
    el.setAttribute('readonly', '');
    el.style.position = 'fixed';
    el.style.top = '0';
    el.style.left = '0';
    el.style.width = '2em';
    el.style.height = '2em';
    el.style.padding = '0';
    el.style.border = 'none';
    el.style.outline = 'none';
    el.style.boxShadow = 'none';
    el.style.background = 'transparent';
    el.style.opacity = '0';
    el.style.pointerEvents = 'none';
    document.body.appendChild(el);

    el.focus();
    el.select();
    el.setSelectionRange(0, value.length);

    const ok = document.execCommand('copy');
    document.body.removeChild(el);
    return ok;
  } catch {
    return false;
  }
}

export async function downloadMediaSafe(url, fileName = 'ips-media') {
  if (!url) return false;

  const safeName = String(fileName || 'ips-media').replace(/[^\w.\-()]/g, '_') || 'ips-media';

  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error('fetch failed');
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = blobUrl;
    anchor.download = safeName;
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    setTimeout(() => URL.revokeObjectURL(blobUrl), 2000);
    return true;
  } catch {
    try {
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = safeName;
      anchor.target = '_blank';
      anchor.rel = 'noopener noreferrer';
      anchor.style.display = 'none';
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      return true;
    } catch {
      window.location.assign(url);
      return false;
    }
  }
}
